module.exports = __webpack_public_path__ + "img/marketing-careers.c5d7d81f.jpg";